
import React from "react";
import { BusinessToolsPanel } from "@/components/business/BusinessToolsPanel";

export default function BusinessToolsPage() {
  return (
    <div className="py-4">
      <BusinessToolsPanel />
    </div>
  );
}
